(function ($) {
    // SEARCH CAROUSEL
    (function() {
        const articleCarousel = $('.js-search-carousel');
        if (articleCarousel) {
            articleCarousel.each(function() {
                const fraction = $(this).find(".swiper-fraction");
                let slideCount = 1;
                fraction.textContent = `<div class="swiper-fraction__item">1</div><div class="swiper-fraction__line"></div><div class="swiper-fraction__item">${slideCount}</div>`;
                const swiper = new Swiper(this, {
                    freeMode: false,
                    centeredSlides: false,
                    slidesPerView: 1,
                    touchRatio: 0.2,
                    slideToClickedSlide: true,
                    watchOverflow: true,
                    on: {
                        init: () => {
                            slideCount = $(this).find('.swiper-pagination-bullet').length;
                            fraction.html(`<div class="swiper-fraction__item">${1}</div><div class="swiper-fraction__line"></div><div class="swiper-fraction__item">${slideCount}</div>`);
                        },
                        slideChange: () => {
                            fraction.html(`<div class="swiper-fraction__item">${swiper.realIndex + 1}</div><div class="swiper-fraction__line"></div><div class="swiper-fraction__item">${slideCount}</div>`);
                        }
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: document.querySelector('.slider-button-next'),
                        prevEl: document.querySelector('.slider-button-prev'),
                    },
                    observer: true,
                    observeParents: true,
                    observeSlideChildren: true
                });
            });
        }

        const articleCarouselClass = '.js-search-carousel';
        const wrapperContainer = '.p-wrapper__container';
        const searchBgClass = 'p-wrapper__container--search-bg';
        ready(articleCarouselClass, function(element) {
            if ($(this).length) {
                $(this).parents(wrapperContainer).addClass(searchBgClass);
            }
            else {
                $(this).parents(wrapperContainer).removeClass(searchBgClass);
            }
        });

        const readyEl = '.swiper-pagination-lock';
        const parent = '.js-search-carousel';
        const lockClass = 'is-lock';
        ready(readyEl, function(element) {
            if ($(this).length) {
                $(this).parents(parent).addClass(lockClass);
            }
            else {
                $(this).parents(parent).removeClass(lockClass);
            }
        });
    }());

})(jQuery);
